import regexPatterns from './regexPatterns'

const checkHasCredentials = value => {
    if (regexPatterns.base64.test(value)) {
        const decodedValue = atob(value)
        const [username, password] = decodedValue.split(':')
        if (username && password) {
            return true
        }
    }
    return false
}

const extractHeaders = resource => {
    const headerKeys = ['authorization']
    const headerPrefixes = ['basic', 'bearer']
    const [basicPrefix] = headerPrefixes

    const authorizationHeader = {}
    const remainingHeaders = {}

    let headers = JSON.parse(resource?.headers)

    for (const key in headers) {
        const lowercaseKey = key.toLowerCase()
        const headerValue = headers[key]
        const splitedHeaderValue = headerValue?.split(' ')
        const [prefix, token] = splitedHeaderValue

        if (!headerKeys.includes(lowercaseKey)) {
            remainingHeaders[key] = headerValue
            continue
        }

        const matchingPrefix = headerPrefixes.find(item => prefix.toLowerCase() === item)
        if (matchingPrefix && (matchingPrefix !== basicPrefix || checkHasCredentials(token))) {
            authorizationHeader[key] = headerValue
            continue
        }

        remainingHeaders[key] = headerValue
    }

    return {
        authorizationHeader,
        remainingHeaders
    }
}

const parseAuthorizationHeader = (authorizationHeader = '') => {
    const basicMatch = regexPatterns.basicToken?.test(authorizationHeader)
    const bearerMatch = regexPatterns.bearerToken?.test(authorizationHeader)

    const splitedHeader = authorizationHeader.split(' ')
    const [, credentials] = splitedHeader

    if (basicMatch && regexPatterns.base64.test(credentials)) {
        const decodedCredentials = atob(credentials)
        const [username, password] = decodedCredentials.split(':')

        return {
            type: 'basic_auth',
            username,
            password
        }
    }
    if (bearerMatch) {
        const [, token] = splitedHeader
        return {
            type: 'bearer_token',
            token
        }
    }
}

export {
    extractHeaders,
    parseAuthorizationHeader
}
